/***
 * Created on 2024/1/9
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import SwitchInput from "../common/form/switch_input";
import {useTranslation} from "react-i18next";
import {SocialPlatformService, getErrorMessage} from 'common/ServiceCommon';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {apiPost} from "../../service/api";
import UnlinkWarningDialog from "./dialog/unlink_warning_dialog";
import {useBoundedStore} from 'common/Store';

function SocialLinkage({user}) {
    const { t } = useTranslation();
    const [showUnlinkWarning, setShowUnlinkWarning] = useState(false);
    const [currentPlatform, setCurrentPlatform] = useState();
    const socialService = new SocialPlatformService();
    const store = useBoundedStore();
    const queryClient = useQueryClient()

    const doLinkMutation = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/link_platform', data),
        onSuccess: data => {
            console.log(data);
            queryClient.invalidateQueries({
                queryKey: ['profile']
            });
            const message =  t('@Link {social_network} account.@', {
                social_network: SocialPlatformService.getPlatformName(currentPlatform),
                interpolation: {
                    prefix: '{',
                    suffix: '}',
                    escapeValue: false
                }
            })
            store.globalAlert.setAlert(message, 'success', true);
        },
        onError: (error, variables, context) => {
            console.log(error);
            // handleSocialResponse(null, error, variables, context);
            const message = getErrorMessage(t, error?.cause?.code, {
                params: {
                    platform: SocialPlatformService.getPlatformName(currentPlatform)
                },
                prefix: '{',
                suffix: '}'
            });
            store.globalAlert.setAlert(message, 'error', true);
        }
    })

    const socialLink = async (e, linkage, platform) => {
        console.log(platform);
        setCurrentPlatform(platform);
        if (linkage) {
            await socialService.linkPlatform(platform, doLinkMutation.mutate);
        }
        else {
            setShowUnlinkWarning(true);
        }
    }

    return (
        <>
            <SwitchInput label={t('@Allow Facebook login@')} value={!!user?.linked?.facebook} opts="facebook" callBack={socialLink}/>
            <SwitchInput label={t('@Allow Google login@')} value={!!user?.linked?.google} opts="google" callBack={socialLink}/>
            <SwitchInput label={t('@Allow Apple login@')} value={!!user?.linked?.appleid} opts="appleid" callBack={socialLink}/>
            <SwitchInput label={t('@Allow Weixin login@')} value={!!user?.linked?.weixin} opts="weixin" callBack={socialLink}/>

            {showUnlinkWarning && <UnlinkWarningDialog showModal={showUnlinkWarning} closeModal={()=>setShowUnlinkWarning(false)} platform={currentPlatform} socialService={socialService}/>}
        </>
    );
}

export default SocialLinkage;